export function formatVimeoLink(vimeoUri: string) {
  const vimeoId = vimeoUri.split("/").pop();

  if (!vimeoId) {
    return "";
  }

  return `player.vimeo.com/video/${vimeoId}`;
}
